var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElinoiLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 306,
    viewBox: "0 0 580 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 62.665V302.745H88.7921V255.072H54.8529V200.539H87.7654V152.867H54.8529V110.338H88.454V62.665H0Z",
    fill: "#222426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.123 62.665V302.745H184.915V255.072H151.186V62.665H96.123Z",
    fill: "#222426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.803 302.745H245.381V62.665H190.803V302.745Z",
    fill: "#222426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.839 62.665L341.252 207.399H338.159L312.367 62.665H252.527V302.745H307.552L295.513 159.042H298.61L323.025 302.745H382.864V62.665H327.839Z",
    fill: "#222426"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 59,
    width: 127,
    height: 247
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.367 59.0581H516.326V306H390.367V59.0581Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.281 247.009C445.281 255.238 449.058 258.328 453.173 258.328C457.635 258.328 461.412 255.238 461.412 247.009V118.05C461.412 109.478 457.635 106.735 453.173 106.735C449.058 106.735 445.281 109.478 445.281 118.05V247.009ZM452.488 59.0581C491.959 59.0581 516.326 81.0113 516.326 122.166V242.55C516.326 284.052 491.959 306.001 452.488 306.001C413.36 306.001 390.367 284.394 390.367 242.55V122.166C390.367 80.3224 413.36 59.0581 452.488 59.0581Z",
    fill: "#222426"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 580,
    height: 306
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.814453 306H580V0H0.814453V306Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.881 302.572H579.137V62.4893H523.881V302.572Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6402 14.2298L27.5893 47.1018L16.4688 32.6478L58.6187 -0.00146484L69.6402 14.2298Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579 34.4891L566.286 21.7842L553.572 34.4891L566.286 47.1941L579 34.4891Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.305 34.4891L536.591 21.7842L523.877 34.4891L536.591 47.1941L549.305 34.4891Z",
    fill: "#222426"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElinoiLogoBlack);
export default __webpack_public_path__ + "static/media/elinoi-logo-black.9f7ee67b50a5e3b82d0f97853f85fe45.svg";
export { ForwardRef as ReactComponent };